export const historyPerpage = 10;
const perpage = 10;

export default perpage;
